export default __webpack_public_path__ + "static/media/Add-Statements.d768ff88.png";